import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { academyGet } from './academyApi';
import { workspaceHref } from './trainingRoutes';

export default function AcademyWorkspaceEntry({ manage = false }) {
  const [meta, setMeta] = useState(null);
  useEffect(() => {
    const controller = new AbortController();
    Promise.resolve(academyGet('/courses/workspace/meta', controller.signal)).then(result => {
      if (!controller.signal.aborted) setMeta(result?.response || null);
    }).catch(() => {});
    return () => controller.abort();
  }, []);
  if (!meta) return null;
  if (manage) return (meta.canInitialize || meta.owner) ? <p><Link to={workspaceHref('access')}>{meta.owner ? 'Manage training access' : 'Set up training access'} →</Link></p> : null;
  return meta.allowed ? <Link className="academy-tool" to={workspaceHref('paths')}><strong>Learning paths</strong><span>Open learning paths within Training →</span></Link> : null;
}
